import { Box, Stack, Theme, Typography, useMediaQuery } from "@mui/material";
import React, { FC, ReactNode } from "react";
import { OrderPill } from "@sinch/components/Pill/Pill";

export type OrderNameProps = {
  id?: number | string | null;
  name?: ReactNode | null;
  variant?: "smallTitle" | "regularLine";
};

export const OrderName: FC<OrderNameProps> = ({ variant, name, id }) => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));

  return (
    <Stack alignItems="center" direction="row" flexWrap={isMobile ? "wrap" : "nowrap"} spacing={1}>
      {name && (
        <Typography
          component="span"
          sx={(theme) => ({
            fontSize: variant === "regularLine" ? theme.typography.body1.fontSize : theme.typography.pxToRem(15),
          })}
        >
          {name}
        </Typography>
      )}
      {id && (
        <Box>
          <OrderPill id={id} size="small" />
        </Box>
      )}
    </Stack>
  );
};
